export default {
  methods: {
    toDegrees(angleInRadians) {
      return angleInRadians * 180 / Math.PI
    },
    toRadians(angleInDegrees) {
      return angleInDegrees * Math.PI / 180
    },
    /**
     * pt1からpt2に向かったときの真北との角度差をdegで返す.
     * 範囲は-180から180度、真北から東側がプラス、西側がマイナス.
     * https://www.movable-type.co.uk/scripts/latlong.html
     */
    getBearing(pt1, pt2) {
      const lat1 = this.toRadians(pt1.lat)
      const lon1 = this.toRadians(pt1.lon)
      const lat2 = this.toRadians(pt2.lat)
      const lon2 = this.toRadians(pt2.lon)
      const y = Math.sin(lon2 - lon1) * Math.cos(lat2)
      const x = Math.cos(lat1) * Math.sin(lat2) -
        Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1)
      // from -180 to 180 degrees
      return this.toDegrees(Math.atan2(y, x))
    },
    getDistance(pt1, pt2) {
      const lat1 = this.toRadians(pt1.lat)
      const lon1 = this.toRadians(pt1.lon)
      const lat2 = this.toRadians(pt2.lat)
      const lon2 = this.toRadians(pt2.lon)

      // 緯度差
      const latDiff = lat1 - lat2
      // 経度差
      const lonDiff = lon1 - lon2
      // 平均緯度
      const latAvg = (lat1 + lat2) / 2.0
      // 赤道半径
      const a = 6378137.0
      // 極半径
      // const b = 6356752.314140356
      // 第一離心率^2
      const e2 = 0.00669438002301188
      // 赤道上の子午線曲率半径
      const a1e2 = 6335439.32708317

      const sinLat = Math.sin(latAvg)
      const W2 = 1.0 - e2 * Math.pow(sinLat, 2)

      // 子午線曲率半径M
      const M = a1e2 / Math.sqrt(Math.pow(W2, 3))
      // 卯酉線曲率半径
      const N = a / Math.sqrt(W2)

      const t1 = M * latDiff
      const t2 = N * Math.cos(latAvg) * lonDiff
      return Math.round(Math.sqrt(Math.pow(t1, 2) + Math.pow(t2, 2)))
    }
  },
}
